// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { XMyListDetailsTagsModelStateType } from "@ces/App/Store/Reducers";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<XMyListDetailsTagsModelStateType>;

export const DispatchOpenTagsModel: HandlerType = props => {
    props.dispatch({
        type: "xMyListDetails/TagsModel/SetTagsModelIsOpen",
        isOpen: props.parameter.isOpen,
    } as any);
};

export const chain = [DispatchOpenTagsModel];

const openTagsModel = createHandlerChainRunner(chain, "openTagsModel");
export default openTagsModel;
